import { combineReducers } from 'redux';

// REDUX - REDUCERS

// {/* -=-=-=-=-==-=-=-=-    Local Reducers    -=-=-=-=-==-=-=-=- */}

import { loader, languageSupport, generalDetails, featureAccess, C1Banner, CampaignStatus, CcbpState } from './Local';

// {/* -=-=-=-=-==-=-=-=-    Api Reducers    -=-=-=-=-==-=-=-=- */}

import {
	homeDetails,
	bankList,
	merchantAccountDetails,
	txnStatus,
	txnList,
	kycDetails,
	billDetails,
	cardDetails,
	pincodeDetails,
	prePaidTxnStatus,
	prePaidTxnList,
	sendMoneyTxnStatus,
	sendMoneyBankList,
	matchDetails,
	postPeContactList,
	repaymentHistory,
} from './Api';

const rootReducer = combineReducers({
	// {/* -=-=-=-=-==-=-=-=-    Local Reducers    -=-=-=-=-==-=-=-=- */}

	loader,
	languageSupport,
	generalDetails,
	featureAccess,

	// {/* -=-=-=-=-==-=-=-=-    Api Reducers    -=-=-=-=-==-=-=-=- */}

	homeDetails,
	bankList,
	merchantAccountDetails,
	txnStatus,
	txnList,
	kycDetails,
	billDetails,
	cardDetails,
	pincodeDetails,
	prePaidTxnStatus,
	prePaidTxnList,
	sendMoneyTxnStatus,
	sendMoneyBankList,
	matchDetails,
	postPeContactList,
	repaymentHistory,
	C1Banner,
	CampaignStatus,
	CcbpState,
});
export default rootReducer;
